module.exports = "img/flags/BE.09bbba7.png";